import axios from 'axios';
import { groupBy, mergeArrsByKey } from '@/helpers';

import { httpWithLoader } from '@/http-common';

const state = () => ({
    accessToken: null, // Токен для авторизации
    accessTokenInitTime: null // Время жизни токена
});

const getters = {};

const mutations = {
    // Изменение токена для авторизации
    SET_ACCESS_TOKEN(state, accessToken) {
        state.accessToken = accessToken
    },
    // Изменение времени жизни токена
    SET_ACCESS_TOKEN_INIT_TIME(state) {
        state.accessTokenInitTime = +new Date()
    },
    // Обнуление времени жизни токена
    NULLIFY_ACCESS_TOKEN_INIT_TIME(state) {
        state.accessTokenInitTime = ''
    },
};

const handleError = ((error, commit) => {
    commit('common/TOGGLE_ALERT', { open: true, status: 'error', text: `Что то пошло не так, пожалуйста перезагрузите страницу и попробуйте ещё раз` }, { root: true })
    console.log(`url: ${ error.config ? error.config.url : '-' }\nmethod: ${ error.config ? error.config.method : '-' }\npayload: ${ error.config ? error.config.data : '-' }`);

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const tempMessage = error.response.data.trace.map(el => el.file).join('\n')
        console.log(`message: ${error.response.data.message}\nfiles:\n${tempMessage}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the 
        // browser and an instance of
        // httpWithLoader.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Ошибка', error.message);
    }
});

const actions = {
    /*--------- USER --------*/
    // Авторизация
    async LOGIN({ commit }, { email, password }) {
        return await httpWithLoader.post(`/auth/login`, {email, password})
        .then((response) => {
            commit('SET_ACCESS_TOKEN', response.data.access_token)
            commit('SET_ACCESS_TOKEN_INIT_TIME')

            return response.status
        })
        .catch(reject => {
            handleError(reject, commit)

            return reject.response.status
        });
    },
    // Выход из аккаунта
    async LOGOUT({ commit, state }) {
        await httpWithLoader.post(`/auth/logout`, null , {
            headers: {
                'Authorization': `bearer ${state.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ACCESS_TOKEN', '')
            commit('NULLIFY_ACCESS_TOKEN_INIT_TIME')
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    // Обновление токена
    async UPDATE_TOKEN({ commit, state }) {
        return await httpWithLoader.post(`/auth/refresh`, null , {
            headers: {
                'Authorization': `bearer ${state.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ACCESS_TOKEN', response.data.access_token)
            commit('SET_ACCESS_TOKEN_INIT_TIME')

            return response.status
        })
        .catch(reject => {
            handleError(reject, commit)

            return reject.response.status
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
